import { render, staticRenderFns } from "./CommentsContainer.vue?vue&type=template&id=64e1ca06&"
import script from "./CommentsContainer.vue?vue&type=script&lang=js&"
export * from "./CommentsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e1ca06')) {
      api.createRecord('64e1ca06', component.options)
    } else {
      api.reload('64e1ca06', component.options)
    }
    module.hot.accept("./CommentsContainer.vue?vue&type=template&id=64e1ca06&", function () {
      api.rerender('64e1ca06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/comments/CommentsContainer.vue"
export default component.exports